import { render, staticRenderFns } from "./KimBackground.vue?vue&type=template&id=4308d6dc&scoped=true&"
import script from "./KimBackground.vue?vue&type=script&lang=js&"
export * from "./KimBackground.vue?vue&type=script&lang=js&"
import style0 from "./KimBackground.vue?vue&type=style&index=0&id=4308d6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308d6dc",
  null
  
)

export default component.exports